import { Injectable } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {

  private longTaskThreshold = 18 * 1_000; // Long task threshold in milliseconds
  private lastLongTaskAt: number | null = null;

  constructor(
    private loggingService: LoggingService,
  ) {
    this.monitorLongTasks();
  }

  monitorLongTasks() {
    if ('PerformanceObserver' in window) {
      try {
        const observer = new PerformanceObserver((list: PerformanceObserverEntryList) => {
          list.getEntries().forEach((entry: PerformanceEntry) => {
            if (entry.duration > this.longTaskThreshold) {
              this.lastLongTaskAt = Date.now();
              this.loggingService.logError('Long task detected', new Error(`Task [${entry.name}] duration: ${entry.duration}`));
            }
          });
        });
        observer.observe({ entryTypes: ['longtask'] });
      } catch (error) {
        this.loggingService.logError('Failed to create PerformanceObserver', error);
      }
    } else {
      this.loggingService.logWarning('PerformanceObserver is not supported in this browser.');
    }
  }

  getLongTaskDetected(): boolean {
    return this.lastLongTaskAt !== null && Date.now() - this.lastLongTaskAt < 60000;
  }
}
